import { Calendar } from "react-multi-date-picker";
import { useEffect, useState } from "react";
import { format } from "date-fns";
import CalendarIcon from "../../icons/calendarIcon";
import { useRef } from "react";

const DateSearchInput = ({
  placeholder,
  name,
  disabled,
  formik,
  label,
  noPast,
  max,
  min,
  dateFormat,
}) => {
  const [date, setDate] = useState("");
  const [open, setOpen] = useState(false);
  const calendarRef = useRef(null);

  const handleDateChange = (selectedDate) => {
    const { year, month, day } = selectedDate;
    const newDate = format(
      new Date(year, month.index, day),
      dateFormat || "yyyy/MM/dd"
    );

    setDate(newDate);

    if (formik) {
      formik.setFieldValue(name, newDate);
    }
    setOpen(false);
  };

  const handleClickOutside = (event) => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setOpen(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div className="relative w-full">
      {label && (
        <label className="block mb-1 font-semibold capitalize text-primary">
          {label}
        </label>
      )}

      <div className="border-[#88888880] relative border  rounded-[5px] px-2">
        <div onClick={() => setOpen(true)} className="flex items-center gap-1">
          <CalendarIcon fill={"white"} />
          <input
            type={"text"}
            name={name}
            readOnly
            placeholder={placeholder}
            onBlur={formik && formik.handleBlur}
            value={(formik && formik.getFieldMeta(name)?.value) || ""}
            disabled={disabled}
            className="flex-1 w-full h-8 px-2 py-2 bg-transparent focus-visible:outline-none"
            autoComplete="off"
          />
        </div>

        {open && (
          <div
            ref={calendarRef}
            className="absolute z-10 -translate-x-1/2 top-[110%] left-1/2"
          >
            <Calendar
              onChange={handleDateChange}
              value={date}
              minDate={noPast ? new Date() : min ? min : null}
              maxDate={max ? max : null}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DateSearchInput;
